import * as Sentry from '@sentry/browser';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { MOCK_FEATURE_FLAGS } from 'api/mocks/data/mockFeatureFlags';
import { FeatureFlag } from 'types/FeatureFlags';

/** Returns the value for a LaunchDarkly feature flag */
export default function useFeatureFlag(flag?: FeatureFlag) {
  const flags = useFlags();

  if (!flag || !flags) {
    return undefined;
  } else if (
    import.meta.env.VITE_APP_MOCK_FLAGS === 'true' &&
    import.meta.env.VITE_APP_DEPLOY_ENV !== 'test'
  ) {
    return MOCK_FEATURE_FLAGS[flag];
  }

  const status = flags[flag];
  Sentry.setTag(
    `flag.${flag}`,
    typeof flags[flag] === 'object' ? !!Object.keys(flags[flag]).length : flags[flag],
  ); // Track flag status in Sentry
  return status;
}
